import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, ListGroup, Spinner } from 'react-bootstrap';
import { apiFetch } from '../api';

// Page « Activer mon compte » : un membre OGOG déjà dans l'annuaire se retrouve,
// se sélectionne, et demande l'activation avec son email réel. Il reçoit alors
// un lien d'activation par email (flux dans backend/onboarding/request.php).
const OnboardingStart = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [selected, setSelected] = useState(null);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setResults([]);
    if (query.trim().length < 2) {
      setError('Entrez au moins 2 lettres de votre nom.');
      return;
    }
    setSearching(true);
    try {
      const data = await apiFetch(`/backend/onboarding/search_members.php?q=${encodeURIComponent(query.trim())}`);
      setResults(data.members || []);
      if ((data.members || []).length === 0) {
        setError("Aucun membre trouvé (ou déjà activé). Vérifiez l'orthographe ou contactez l'administrateur.");
      }
    } catch (err) {
      setError('Erreur lors de la recherche. Réessayez plus tard.');
    } finally {
      setSearching(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!selected || !email) {
      setError('Sélectionnez votre nom et indiquez votre email.');
      return;
    }
    setLoading(true);
    try {
      const data = await apiFetch('/backend/onboarding/request.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: selected.id, email }),
      });
      if (data.success) {
        setMessage(data.message || "Lien d'activation envoyé. Consultez votre boîte email.");
      } else {
        setError(data.message || 'Une erreur est survenue.');
      }
    } catch (err) {
      setError('Erreur serveur. Réessayez plus tard.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={7}>
          <Card>
            <Card.Body>
              <Card.Title>Activer mon compte membre</Card.Title>
              <p className="text-muted">
                Vous êtes membre de l'OGOG et apparaissez déjà dans l'annuaire ? Activez votre
                compte pour compléter votre profil (photo, biographie…) et accéder à l'espace membre.
              </p>

              {message && <Alert variant="success">{message}</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}

              {!message && (
                <>
                  {/* Étape 1 : recherche */}
                  <Form onSubmit={handleSearch} className="mb-3">
                    <Form.Label><strong>1. Retrouvez-vous dans l'annuaire</strong></Form.Label>
                    <div className="d-flex gap-2">
                      <Form.Control
                        type="text"
                        placeholder="Votre nom de famille"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                      />
                      <Button type="submit" variant="outline-primary" disabled={searching}>
                        {searching ? <Spinner size="sm" animation="border" /> : 'Rechercher'}
                      </Button>
                    </div>
                  </Form>

                  {/* Liste des résultats */}
                  {results.length > 0 && (
                    <ListGroup className="mb-3">
                      {results.map((m) => (
                        <ListGroup.Item
                          key={m.id}
                          action
                          active={selected && selected.id === m.id}
                          onClick={() => setSelected(m)}
                        >
                          {m.first_name} {m.name}
                          {m.zipCity ? <span className="text-muted"> — {m.zipCity}</span> : null}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}

                  {/* Étape 2 : email + envoi */}
                  {selected && (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <strong>2. Votre email</strong> (celui que vous utiliserez pour vous connecter)
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="prenom.nom@exemple.ch"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        <Form.Text className="text-muted">
                          Vous recevrez un lien d'activation à cette adresse, alors utilisez un email
                          que vous consultez.
                        </Form.Text>
                      </Form.Group>
                      <div className="d-flex justify-content-end">
                        <Button type="submit" variant="primary" disabled={loading}>
                          {loading ? 'Envoi…' : `Activer le compte de ${selected.first_name} ${selected.name}`}
                        </Button>
                      </div>
                    </Form>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OnboardingStart;
